module.exports.main = `
  INSERT INTO fin.customer (
     origin, company, customer_id,
     active, name, balance
  )
  SELECT origin
       , company
       , customer_id
       , (data->>'Active')::BOOLEAN as active
       , (data->>'DisplayName') as name
       , (data->>'Balance')::NUMERIC as balance
  FROM raw
`
